import { Observable } from 'rxjs';
import {
  SampleForExtraction,
  ManualExtractionData
} from '../../../model/associate-extraction/manual/manual-extraction.model';

/**
 * Abstract repository for manual extraction operations
 * Defines the contract for extraction data management
 * HU23-920839: Carga Manual de Datos de Extracción
 */
export abstract class ManualExtractionRepository {
  /**
   * Search sample by specimen code for extraction
   * @param specimenCode Specimen code to search
   * @returns Observable with sample data ready for extraction
   */
  abstract searchSample(specimenCode: string): Observable<SampleForExtraction>;

  /**
   * Register manual extraction data for a specimen
   * @param data Manual extraction data including concentrations and ratios
   * @returns Observable that completes on success
   */
  abstract registerExtraction(data: ManualExtractionData): Observable<void>;
}
